import { ReactNode } from 'react';
import { fspTheme } from './theme';
import { GetBrandTheme } from '@leadflow/shared/theme/GetBrandTheme';

const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
  return <GetBrandTheme brandTheme={fspTheme}>{children}</GetBrandTheme>;
};

export default ThemeProviderWrapper;
